import ProductSalesDashboard from '@/components/productos/ProductSalesDashboard'

export default function ProductosPage() {
  return <ProductSalesDashboard />
}
